/**
 * 提示词分类定义
 * 涵盖多模态AI应用场景
 */

export const PROMPT_CATEGORIES = [
  // 文本类
  { value: '内容创作', label: '内容创作', icon: '✍️', description: '文章、文案、创意写作' },
  { value: '商业策略', label: '商业策略', icon: '💼', description: '商业分析、策略规划' },
  { value: '技术开发', label: '技术开发', icon: '💻', description: '代码生成、技术文档' },
  { value: '教育培训', label: '教育培训', icon: '📚', description: '教学设计、知识问答' },
  { value: '客户服务', label: '客户服务', icon: '🛎️', description: '客服话术、问题解答' },
  
  // 多模态类
  { value: '图像生成', label: '图像生成', icon: '🖼️', description: '图片分析、视觉理解' },
  { value: '音频生成', label: '音频生成', icon: '🎵', description: '语音识别、音频分析' },
  { value: '视频生成', label: '视频生成', icon: '🎬', description: '视频理解、内容分析' },
  
  // 数据类
  { value: '数据分析', label: '数据分析', icon: '📊', description: '数据挖掘、报表生成' },
  { value: '金融财务', label: '金融财务', icon: '💰', description: '财务分析、投资建议' },
  
  // 通用类
  { value: '日常助手', label: '日常助手', icon: '🤖', description: '生活助手、通用问答' },
  { value: '其他', label: '其他', icon: '📝', description: '其他类型提示词' }
] as const;

export type PromptCategory = typeof PROMPT_CATEGORIES[number]['value'];

export const getCategoryInfo = (category: string) => {
  return PROMPT_CATEGORIES.find(cat => cat.value === category);
};

export const getCategoryIcon = (category: string) => {
  const info = getCategoryInfo(category);
  return info?.icon || '📝';
}; 